import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  activeTab: any;
  children: string;
  id: any;
  clickCode: string;
  onClick: (id: any) => void;
}

export default function Tab({
  activeTab,
  children,
  id,
  clickCode,
  onClick,
}: IProps) {
  return (
    <button
      className={cx('Tab')}
      type="button"
      aria-selected={activeTab === id}
      data-event-nlog="click"
      data-event-area-code={clickCode}
      onClick={() => onClick(id)}
    >
      <span className={cx('name')}>{children}</span>
    </button>
  );
}
